import {Router} from '@angular/router';
import {MenuController, Platform} from '@ionic/angular';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  params: any;
  cns: any;

  constructor(private platfom: Platform,
              private menuCtrl: MenuController,
              private router: Router) {

  }

  setParams(params) {
    if (params && params.state) {
      this.params = params;
    }
  }

  getParams() {
    return this.params;
  }

  changeRoutePWA(route, params?) {
    this.menuCtrl.enable(true);
    if (params) {
      this.setParams(params);
    }
    if (route.indexOf('tabs') !== -1) {
      route = route.replace('/tabs', '');
      this.router.navigate([route]);
    }
  }

  changeRouteMobile(route, params?) {
    this.menuCtrl.enable(false);
    if (params) {
      this.setParams(params);
    }
    if (route.indexOf('tabs') === -1) {
      this.router.navigate(['/tabs' + route]);
    }
  }
}
